import { render, staticRenderFns } from "./imgZ.vue?vue&type=template&id=d1a18a8a"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1a18a8a')) {
      api.createRecord('d1a18a8a', component.options)
    } else {
      api.reload('d1a18a8a', component.options)
    }
    module.hot.accept("./imgZ.vue?vue&type=template&id=d1a18a8a", function () {
      api.rerender('d1a18a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgZ.vue"
export default component.exports